<template>
  <a-select
    show-search
    :default-active-first-option="false"
    :allowClear="true"
    v-model="selectedItem"
    :filter-option="false"
    :not-found-content="fetching ? undefined : null"
    @change="emitModelValue"
    @search="fetchUser"
  >
    <a-spin v-show="fetching" slot="notFoundContent" size="small" />

    <a-select-option v-for="i in items" :value="i.id" :key="i.id">
      <b v-text="i.fullname || i.username"></b><br />
      <span v-text="i.email"></span>
    </a-select-option>
  </a-select>
</template>
<script>
import debounce from "lodash/debounce";
import gql from "graphql-tag";
const userQuery = gql`
  query users($query: String) {
    users(query: $query) {
      id
      fullname
      username
      email
    }
  }
`;
export default {
  props: {
    listItem: Array,
    value: [String, Number, Object, Array],
  },
  data() {
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);
    return {
      items: [],
      selectedItem: undefined,
      fetching: false,
    };
  },
  methods: {
    emitModelValue() {
      this.$emit("input", this.selectedItem);
    },
    fetchUser(value) {
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.users = [];
      this.fetching = true;

      this.$apollo
        .query({
          query: userQuery,
          variables: { query: value },
        })
        .then((body) => {
          if (fetchId !== this.lastFetchId) {
            // for fetch callback order
            return;
          }
          this.items = body.data?.users;
          this.fetching = false;
        })
        .catch((error) => {
          console.log("Lỗi lấy ds user", error);
          this.fetching = false;
        });
    },
  },
  created() {
    if (this.listItem) {
      this.items = this.listItem;
    } else {
      if (this.listItem) {
        this.items = this.listItem;
      } else {
        this.fetchUser();
      }
    }

    this.selectedItem = this.value;
  },
};
</script>
